import CrownIcon from "./CrownIcon.mjs";

/** @type {GlyphIcon} */
export default CrownIcon;
